import React, { useMemo } from 'react';
import { isEmpty } from '@/shared/utility';
import GameCard from '@/pages/games/game-card/GameCard';
import { GamesStreamlineSectionCommonProps } from '@/components/shared/games/GamesStreamlineSection';
import Streamline from '@/components/shared/streamline/Streamline';
import Large from '@/components/shared/streamline/children-layouts/Large';

function GamesLargeStreamline({ games, category }: GamesStreamlineSectionCommonProps): JSX.Element {
  const children = useMemo(() => {
    if (isEmpty(games)) return <div />;
    return games.map(game => (
      <Large key={`/${category}/${game.slug}/${game.gameId}`}>
        <GameCard game={game} category={category} large />
      </Large>
    ));
  }, [games, category]);

  return <Streamline children={children} />;
}

export default GamesLargeStreamline;
